module.exports = __webpack_public_path__ + "img/quiz_07.c639ac44.jpg";